export const CLASS_ACTIONS = {
  SET_STATE: "classes/setState",
  GET_CLASSES: "classes/getClasses",
  SAVE_CLASS: "classes/saveClass",
  DESTROY: "classes/destroy",
};
